module.exports = __webpack_public_path__ + "media/images/product_lines/car/h4-7917a13d98e1f31e24fb950ce1477ba3.svg";